<template>
    <section class="contentBuilderModule flex-row">
        <svg id="builderShelf" width="100%"></svg>
        <div class="content-edit-shelf">
            <div class="content-edit-shelf-input">
                <div class="content-edit-shelf-input-counter-char">{{ lengthChar }} / {{ maxlengthChar }} CHARACTERS</div>
                <input type="text" v-model="getText" :maxlength="maxlengthChar" />
            </div>
            <button @click="clearText">CLEAR</button>
        </div>
    </section>
</template>

<script>
import { Component } from "./components/Component";
import Globals from "./../globals";
import { mapActions, mapGetters } from "vuex";
import { Shelf } from "./components/Shelf";
import CommentBloc from "../CommentBloc/CommentBloc";
import MenuBar from "../gui/menu/MenuBar";
import MenuItemPlano from "../gui/menu/MenuItem";
import MenuShades from "./menu/MenuShades.vue";

export default {
    components: {
        CommentBloc,
        MenuBar,
        MenuItemPlano,
        MenuShades
    },
    data() {
        return {
            commentData: {
                plano: null,
                component: null,
                componentIdExternal: null
            },
            text: "",
            shelfEditor: null,
            makeSave: false,
            maxlengthChar: 0,
            lengthChar: 0
        };
    },
    watch: {
        onSaveShelfEdit() {
            this.setMode("plano");
            this.makeSave = true;
        }
    },
    computed: {
        ...mapGetters("events/planomassmarket", {
            onSaveShelfEdit: "onSaveShelfEdit"
        }),

        getText: {
            get() {
                return this.text;
            },

            set(value) {
                this.text = value;
                this.lengthChar = !value ? 0 : value.length;
                this.shelfEditor.setText(value);
            }
        }
    },
    created() {},
    async mounted() {
        let shelf = Component.getSelectedComponents()[0];

        let data = this.assign(shelf.getData());
        let { maxlengthChar } = data;
        if (!maxlengthChar) maxlengthChar = 50;
        this.maxlengthChar = maxlengthChar;
        let shelfEditor = await Shelf.createEditor(data, document.querySelector("svg#builderShelf"));
        this.shelfEditor = shelfEditor;
        if (data.text) this.text = data.text;
    },

    beforeDestroy() {
        if (this.makeSave) {
            let shelf = Component.getSelectedComponents()[0];
            shelf.setText(this.text);
            this.makeSave = false;
        }

        this.shelfEditor = null;
    },

    methods: {
        ...mapActions("plano/status", {
            setMode: "setMode"
        }),

        clearText() {
            this.getText = "";
        },

        test() {
            console.log(this.shelfEditor);
        },

        writeText() {},

        getImgPath(imgPath, format) {
            return Globals.getBaseUrl() + imgPath;
        },
        addListeners() {}
    }
};
</script>

<style lang="scss">
.contentBuilderModule {
    height: 90%;
    padding: 10px;
    margin: 10px 50px;
    border: black 2px solid;
    background-color: #ffffff;

    #builderShelf {
        /*margin: 5px;*/
        height: 85%;
        width: 100%;
    }

    .content-edit-shelf {
        width: 100%;
        height: 15%;
        white-space: nowrap;
        .content-edit-shelf-input {
            width: 90%;
            height: 80%;
            display: inline-block;

            .content-edit-shelf-input-counter-char {
                font-weight: bold;
                padding: 2px;
                font-size: 15px;
            }

            input {
                width: 100%;
                height: 100%;
                font-size: 20px;
            }
        }

        button {
            vertical-align: bottom;
            margin: 0 20px;
            padding: 10px;
            border-radius: 10px;
            border: #3c3c3c 1px solid;
            background-color: #f4f4f4;
        }
    }
}

#moduleDetailsSection {
    width: 400px;
    margin-left: 60px;
    #relImgContainer {
        background: #fff;
        max-height: calc(100vh - 230px);
        height: 265px;
        overflow-y: auto;
        margin-bottom: 10px;

        .relatedProductImage {
            display: inline-block;
            vertical-align: top;
            width: 48%;
            margin: 0px 3px;

            .relatedImage {
                > img {
                    width: 70%;
                }
            }
            .refRelated span {
                line-height: 15px;
                font-size: 13px;
            }
        }
    }
}

.relatedImg {
    margin-top: 20px;
}

.cancelBtn {
    top: -102px;
    color: white;
    border: 1px solid white;
}

.closeConfModule {
    color: white;
    border: 1px solid white;
    right: 102px;
    top: -102px;
}

.imagePrincipal {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// ShelfEditor.vue?5d9bf0d8